import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import Config, {
  bhkOptions,
  landlord_property_type,
  PaginationLimit,
  preferredTenantOptions,
  propertyAvailabilityStatus,
  setStatusColor,
} from "../../Config";
import { MdModeEdit } from "react-icons/md";
import { IoMdEye } from "react-icons/io";
import { IoMdMore } from "react-icons/io";
import { capitalizeFirstLetter, truncateText } from "../../helpers";

const Table = ({
  ApiData,
  setSelectedData,
  setEditUser,
  setViewDetail,
  userType,
}) => {
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  const edit = (item) => {
    setEditUser(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const viewDetail = (item) => {
    setViewDetail(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

    const getListingAvatar = (type) => {
    const baseStyle =
      "w-9 h-9 rounded-full flex items-center justify-center text-xs font-semibold";

    switch (type) {
      case 1:
        return <div className={`${baseStyle} bg-blue-50 text-blue-600`}>R</div>;

      case 2:
        return (
          <div className={`${baseStyle} bg-purple-50 text-purple-600`}>S</div>
        );

      case 3:
        return (
          <div className={`${baseStyle} bg-orange-50 text-orange-600`}>L</div>
        );

      default:
        return (
          <div className={`${baseStyle} bg-neutral-100 text-gray-500`}>?</div>
        );
    }
  };

  const ActionBtns = (item) => {
    const openMenu = (id) => {
      setOpenActionMenu((prevId) => {
        return prevId === id ? null : id;
      });
    };

    return (
      <ActionBtnWrapper>
        {openActionMenu === item.id && (
          <MenuOptions id="menuOptions">
            {userType !== Config.userType.MARKETING && (
              <MenuItem title="Edit Detail" onClick={() => edit(item)}>
                <MdModeEdit className="text-gray-700 mr-2" /> Edit Detail
              </MenuItem>
            )}
            <MenuItem title="View Detail" onClick={() => viewDetail(item)}>
              <IoMdEye className="text-gray-700 mr-2" /> View Detail
            </MenuItem>
          </MenuOptions>
        )}
        <Btn title="Actions" type="button" onClick={() => openMenu(item.id)}>
          <IoMdMore className="text-gray-600" size={24} />
        </Btn>
      </ActionBtnWrapper>
    );
  };

  useEffect(() => {
    if (ApiData) {
      const tempData = ApiData.map((item) => ({
        name: getName(item),
        belongsToType: getOwnerBroker(item),
        inventoryType: getInventoryType(item),
        status: getStatus(item.status),
        action: ActionBtns(item),
      }));
      setData(tempData);
    }
  }, [ApiData, openActionMenu]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getName = (item) => {
    const address = capitalizeFirstLetter(item?.address || "");
    const tenant = preferredTenantOptions.find(
      (opt) => opt.value === item?.tenantPreference,
    );

    return (
      <UserImageWrapper>
        {getListingAvatar(item?.listingType)}
        <div className="flex flex-col">
          <span className="text-zinc-900 font-medium">
            {capitalizeFirstLetter(item.inventoryName)}{" "}
            <span className="text-xs bg-zinc-100 text-zinc-500 px-1 py-0.5 rounded-sm">
              {tenant?.label || ""}
            </span>
          </span>
          {address && (
            <span className="text-gray-400 text-xs">
              {truncateText(address, 28)}
              {/* <span className="ml-2 inline-flex items-center justify-center text-[9px] px-[1.5px] font-semibold bg-blue-100 text-blue-700 rounded-full">{item.id}</span> */}
            </span>
          )}
        </div>
      </UserImageWrapper>
    );
  };

  const getInventoryType = (item) => {
    const bhkOption = bhkOptions.find(
      (type) => type.value === item?.inventorySubType,
    );

    const propertyTypeObj = landlord_property_type.find(
      (type) => type.value === item?.inventoryType,
    );

    const bhklabel = bhkOption?.label || "";
    const propertyLabel = propertyTypeObj?.label || "";

    const formatBhk = (label) => {
      if (!label) return "";
      if (label === "Studio") return "Studio";
      if (label === "1 RK") return "1 RK";
      return `${label} BHK`;
    };

    const formattedBhk = formatBhk(bhklabel);

    return (
      <div className="flex flex-col">
        <span className="text-zinc-900 font-medium">{propertyLabel}</span>
        {formattedBhk && (
          <span className="text-xs text-gray-400">#{formattedBhk}</span>
        )}
      </div>
    );
  };

const getOwnerBroker = (item) => {
  let typeShort = "";

  if (item?.belongsToType === 3) typeShort = "O";
  else if (item?.belongsToType === 4) typeShort = "B";

  return (
    <div className="flex flex-col">
      <span className="text-zinc-900 font-medium">
        {capitalizeFirstLetter(item?.belongsToName || "N/A")}

        {typeShort && (
        <span className="text-[11px] text-blue-700 bg-blue-100 px-0.5 ml-1 rounded-full">
          {typeShort}
        </span>
      )}
      </span>
      <span className="text-amber-500 text-xs">
        #{item?.belongsToMobile || "N/A"}
      </span>
    </div>
  );
};

  const getStatus = (status) => {
    const statusObj = propertyAvailabilityStatus.find(
      (item) => item.value === status,
    );

    const label = statusObj?.label || "Nothing";

    return (
      <div
        className={`text-xs border w-24 h-7 flex items-center justify-center rounded-full ${setStatusColor(label)}`}
      >
        {label}
      </div>
    );
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        {
          Header: "Inventory Details",
          accessor: "name",
        },
        {
          Header: "Owner/Broker",
          accessor: "belongsToType",
        },
      ];
    }
    return [
      {
        Header: "Inventory Details",
        accessor: "name",
      },
      {
        Header: "Owner/Broker",
        accessor: "belongsToType",
      },
      {
        Header: "Type",
        accessor: "inventoryType",
      },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ];
  }, [isMobileView]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex },
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination,
  );

  useEffect(() => {
    setCurrentPage(pageIndex); // Update current page on state change
  }, [pageIndex]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  style={column.style}
                >
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${
                          column.isSortedDesc ? "-rotate-90" : "rotate-90"
                        } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        {/* <Tbody {...getTableBodyProps()} hasData={ApiData?.length > 0}> */}
        <Tbody
          {...getTableBodyProps()}
          className={ApiData?.length > 0 ? "border-b" : ""}
        >
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                {/* <Tr {...row.getRowProps()} hasData={ApiData?.length > 1}> */}
                <Tr
                  {...row.getRowProps()}
                  className={ApiData?.length > 1 ? "border-b" : ""}
                >
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        style={cell.column.style}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Address:</strong> {data[rowIndex].address}
                        </li>
                        <li>
                          <strong>Number Of Beds</strong>{" "}
                          {data[rowIndex].numberOfBeds}
                        </li>
                        <li className="flex gap-2">
                          <strong>Status:</strong> {data[rowIndex].status}
                        </li>
                        <li>
                          <strong>Action:</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {ApiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};

const Btn = tw.button`action-btn grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-zinc-500 bg-slate-100`;
const Tbody = tw.tbody`${({ hasData }) => (hasData ? "border-b" : "")}`;
const Tr = tw.tr`${({ hasData }) =>
  hasData ? "border-b" : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-medium text-gray-500`;

const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const UserImageWrapper = tw.div` flex items-center gap-2`;
const MenuOptions = tw.div`absolute bottom-10 right-0 py-4 w-max bg-white z-50 rounded-lg shadow-lg border border-gray-200 flex flex-col max-h-48 overflow-y-auto`;

const MenuItem = tw.div`flex items-center gap-2 px-4 py-2 text-base font-medium cursor-pointer hover:bg-gray-100`;

export default Table;
